import { useEffect, useState } from 'react';
import { AuthorizedPerson } from '../types/client.types';
import { listAuthorizedPersons } from '../services/ClientService';

/**
 * Autorizados del cliente seleccionado. `cancelled` evita que la respuesta de
 * un cliente pise la de otro cuando el cajero salta de uno a otro en la lista;
 * antes eso se resolvia comparando ids dentro del setState.
 */
export const useAuthorizedPersons = (clientId: string | null) => {
    const [persons, setPersons] = useState<AuthorizedPerson[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!clientId) {
            setPersons([]);
            setError(null);
            setIsLoading(false);
            return;
        }

        let cancelled = false;
        setIsLoading(true);
        setError(null);

        listAuthorizedPersons(clientId)
            .then((list) => {
                if (cancelled) return;
                setPersons(list);
                setIsLoading(false);
            })
            .catch((err) => {
                if (cancelled) return;
                setPersons([]);
                setError(err?.message || 'No se pudieron cargar los autorizados.');
                setIsLoading(false);
            });

        return () => { cancelled = true; };
    }, [clientId]);

    return { persons, isLoading, error };
};
